import { Box, Typography } from '@mui/material';
import { PageHeader } from '@/components/navigation/PageHeader';
import { tokens } from '@/theme/tokens';

export function GlobalUsersPage() {
  return (
    <Box sx={{ pb: 4 }}>
      <PageHeader
        title="Global Users"
        subtitle="Manage Super Admin accounts and platform owners."
      />
      
      <Box sx={{ p: 4, backgroundColor: tokens.colors.card, borderRadius: tokens.radius.md, border: `1px solid ${tokens.colors.border}`, textAlign: 'center' }}>
        <Typography variant="h6" fontWeight={600} sx={{ color: tokens.colors.text.secondary }}>
          Global User Management Coming Soon
        </Typography>
        <Typography variant="body2" sx={{ color: tokens.colors.text.muted, mt: 1 }}>
          This area will allow you to create additional Super Admin accounts and view all system owners.
        </Typography>
      </Box>
    </Box>
  );
}
